import { ProductEnvironment, User } from '@cld/unicorn-api';

export const isImpersonationActive = ({
  productEnvironmentAccountId,
  userAccountId,
}: {
  productEnvironmentAccountId: ProductEnvironment['id'];
  userAccountId: User['id'];
}) => productEnvironmentAccountId !== userAccountId;
